import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AlertAnalyzesDemoService {


  constructor() { }

  get(timePeriod: number, rollupGroupCode: string) {
    console.log(rollupGroupCode);
    var label = "";
    var data: string[];
    switch (rollupGroupCode) {
      case "em-4":
        label = "Grpup 1";
        switch (timePeriod) {
          case 2:
            data = ["0", "0", "0", "0", "0", "0", "1", "0", "0", "0", "1", "0"];
            break;
          case 3:
            data = [ "0", "0", "0", "0", "1", "0", "1", "0"]
            break;
          case 4:
            data = ["0", "0", "0", "1", "0", "1"]
            break;
          case 5:
            data = ["0", "0", "1", "0", "0"]
            break;
          case 6:
            data = ["0", "0", "1", "1"]
            break;
        }
        break;
      case "em-1":
        label = "Grpup 2";
        switch (timePeriod) {
          case 2:
            data = ["0", "0", "0", "0", "0", "0", "7", "1", "5", "1", "0", "0"];
            break;
          case 3:
            data = [ "0", "0", "0", "0", "7", "6", "1", "0"]
            break;
          case 4:
            data = ["0", "0", "0", "8", "6", "1"]
            break;
          case 5:
            data = ["0", "0", "7", "7", "0"]
            break;
          case 6:
            data = ["0", "0", "13", "1"]
            break;
        }
        break;
      case "em-2":
        label = "Grpup 3";
        switch (timePeriod) {
          case 2:
            data = ["0", "0", "0", "0", "0", "0", "4", "1", "0", "0", "0", "0"];
            break;
          case 3:
            data = [ "0", "0", "0", "0", "5", "0", "0", "0"]
            break;
          case 4:
            data = ["0", "0", "0", "5", "0", "0"]
            break;
          case 5:
            data = ["0", "0", "5", "0", "0"]
            break;
          case 6:
            data = ["0", "0", "5", "0"]
            break;
        }
        break;
      case "glbl-res-overflow":
        label = "Grpup 4";
        switch (timePeriod) {
          case 2:
            data = ["0", "0", "0", "0", "3", "0", "0", "0", "0", "0", "0", "0"];
            break;
          case 3:
            data = [ "0", "0", "3", "0", "0", "0", "0", "0"]
            break;
          case 4:
            data = ["0", "0", "3", "0", "0", "0"]
            break;
          case 5:
            data = ["0", "3", "0", "0", "0"]
            break;
          case 6:
            data = ["0", "3", "0", "0"]
            break;
        }
        break;
      case "glbl-res":
        label = "Grpup 5";
        switch (timePeriod) {
          case 2:
            data = ["0", "0", "0", "0", "1", "0", "0", "0", "0", "0", "0", "0"];
            break;
          case 3:
            data = [ "0", "0", "0", "0", "1", "0", "1", "0"]
            break;
          case 4:
            data = ["0", "0", "0", "1", "0", "1"]
            break;
          case 5:
            data = ["0", "0", "1", "0", "0"]
            break;
          case 6:
            data = ["0", "0", "1", "1"]
            break;
        }
        break;
      default:
        label = "All Groups";
        switch (timePeriod) {
          case 2:
            data = ["0", "0", "0", "0", "0", "0", "1", "0", "0", "0", "1", "0"];
            break;
          case 3:
            data = [ "0", "0", "0", "0", "1", "0", "1", "0"]
            break;
          case 4:
            data = ["0", "0", "0", "1", "0", "1"]
            break;
          case 5:
            data = ["0", "0", "1", "0", "0"]
            break;
          case 6:
            data = ["0", "0", "1", "1"]
            break;
        }
        break;
    }
    switch (timePeriod) {
      case 2:
        return of({
          Name: "Alerts Timeline",
          LastUpdated: "",
          ChartLabels: [
            "00:00-01:59",
            "02:00-03:59",
            "04:00-05:59",
            "06:00-07:59",
            "08:00-09:59",
            "10:00-11:59",
            "12:00-13:59",
            "14:00-15:59",
            "16:00-17:59",
            "18:00-19:59",
            "20:00-21:59",
            "22:00-23:59"
          ],
          MaxWait: [],
          AvgWait: [],
          MinWait: [],
          Items: [
            {
              label: label,
              data: data
            },
          ]
        }
        );
      case 3:
        return of({
          Name: "Alerts Timeline",
          LastUpdated: "",
          ChartLabels: [
            "00:00-02:59",
            "03:00-05:59",
            "06:00-08:59",
            "09:00-11:59",
            "12:00-14:59",
            "15:00-17:59",
            "18:00-20:59",
            "21:00-23:59"
          ],
          MaxWait: [],
          AvgWait: [],
          MinWait: [],
          Items: [
            {
              label: label,
              data: data
            },
          ]
        }
        );
      case 4:
        return of({
          Name: "Alerts Timeline",
          LastUpdated: "",
          ChartLabels: [
            "00:00-03:59",
            "04:00-07:59",
            "08:00-11:59",
            "12:00-15:59",
            "16:00-19:59",
            "20:00-23:59"
          ],
          MaxWait: [],
          AvgWait: [],
          MinWait: [],
          Items: [
            {
              label: label,
              data: data
            },
          ]
        }
        );
      case 5:
        return of({
          Name: "Alerts Timeline",
          LastUpdated: "",
          ChartLabels: [
            "00:00-04:59",
            "05:00-09:59",
            "10:00-14:59",
            "15:00-19:59",
            "20:00-00:59"
          ],
          MaxWait: [],
          AvgWait: [],
          MinWait: [],
          Items: [
            {
              label: label,
              data: data
            },
          ]
        }
        );
      case 6:
        return of({
          Name: "Alerts Timeline",
          LastUpdated: "",
          ChartLabels: [
            "00:00-05:59",
            "06:00-11:59",
            "12:00-17:59",
            "18:00-23:59"
          ],
          MaxWait: [],
          AvgWait: [],
          MinWait: [],
          Items: [
            {
              label: label,
              data: data
            },
          ]
        }
        );
    }
    return of({
      Name: "Alerts Timeline",
      LastUpdated: "",
      ChartLabels: [
        "00:00-00:59",
        "01:00-01:59",
        "02:00-02:59",
        "03:00-03:59",
        "04:00-04:59",
        "05:00-05:59",
        "06:00-06:59",
        "07:00-07:59",
        "08:00-08:59",
        "09:00-09:59",
        "10:00-10:59",
        "11:00-11:59",
        "12:00-12:59",
        "13:00-13:59",
        "14:00-14:59",
        "15:00-15:59",
        "16:00-16:59",
        "17:00-17:59",
        "18:00-18:59",
        "19:00-19:59",
        "20:00-20:59",
        "21:00-21:59",
        "22:00-22:59",
        "23:00-23:59"
      ],
      MaxWait: [],
      AvgWait: [],
      MinWait: [],
      Items: [
        {
          label: label,
          data: ["0", "0", "0", "0", "0", "0", "0", "0", "5", "0", "0", "0", "8", "4", "1", "1", "1", "4", "1", "0", "0", "0", "0", "0"]
        },
      ]
    }
    );
  }
}

export interface IAlertAnalyzes {
  Name: string;
  LastUpdated: string;
  ChartLabels: string[];
  MaxWait: string[];
  AvgWait: string[];
  MinWait: string[];
  Items: IAlertAnalyzesItem[];
}

interface IAlertAnalyzesItem {
  label: string;
  data: number[];
}